










import { Component, Mixins } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import PadletLogo from 'vuecomponents/PadletLogo.vue'
import ButtonList from 'vuecomponents/button_list.vue'
import BaseButton from 'library/v4/components/base-button.vue'

const browser = namespace('browser')

@Component({
  components: { PadletLogo, ButtonList, BaseButton },
})
export default class HomeNav extends Mixins() {
  @browser.State darkMode
  @browser.Getter isSmallerThanTabletPortrait
}
